module.exports = __webpack_public_path__ + "teqbahn-assets/media/SvetoMuhammadIshoq.b65f675a.jpg";